<template>
  <div
    class="relative h-full bg-gray-500 rounded-md shrink-0 aspect-video"
    :class="[
      collapsed ? 'w-full ' : 'w-16',
      hasBackdrop ? 'bg-transparent' : 'spectra_list_card',
      isAuto && !isSystem ? 'w-auto px-4' : ''
    ]">
    <img
      v-if="showBackdrop"
      :src="listBackdropUrl"
      class="relative flex flex-1 shrink-0 object-cover h-full max-w-full text-white rounded-md aspect-21/9"
      :class="[
        hasBackdrop ? '' : ' saturate-50 brightness-125 mix-blend-multiply'
      ]" />
    <fa-icon
      v-if="!hasBackdrop || isAuto || isSystem"
      :icon="listIcon"
      class="absolute inset-0 m-auto"
      :class="[isAuto ? 'text-white/80 text-sm' : 'text-white/80 text-base']" />
  </div>
  <div
    v-if="!collapsed"
    class="w-full text-left truncate"
    :class="[isAuto ? 'px-1' : 'px-4']">
    <div class="text-sm font-bold text-white truncate">
      {{ list.title }}
    </div>
    <div class="flex flex-row w-full text-center">
      <div
        v-if="!isAuto && !isSystem"
        class="text-xs font-medium text-white/80">
        <fa-icon
          v-if="list.clubs"
          :icon="['fas', 'sparkles']"
          class="mr-1 text-indigo-400 fa-fw"
          title="Club List" />
        <fa-icon
          v-if="list.is_private"
          :icon="['fas', 'lock']"
          class="mr-1 fa-fw" />
        <fa-icon
          v-if="list.is_collaborative"
          :icon="['fas', 'users']"
          class="mr-1 text-indigo-400 fa-fw"
          title="Collaborative" />
        <fa-icon
          v-if="list.is_following"
          :icon="['fas', 'tower-broadcast']"
          class="mr-1 fa-fw" />
      </div>

      <span
        v-if="itemsCount > 0 && !isAuto"
        class="mr-1 text-xs font-medium text-white/80"
        >{{ itemsCount }} items</span
      ><span v-else-if="!isAuto" class="mr-1 text-xs font-medium text-white/40"
        >Empty</span
      >

      <span v-if="list.is_following" class="text-xs font-medium text-white/80"
        >by @{{ list.profiles.username }}</span
      >
      <!-- <span>IS OWNER: {{ list.is_owner }}</span> -->
      <!-- <span>Can Edit: {{ list.can_edit }}</span> -->
      <!-- <span class="text-xs font-medium text-white/80"> &#x2022;</span> -->
      <!-- <span class="text-xs font-medium truncate text-white/80"
        >@{{ list.profiles?.username || 'Unknown User' }}</span
      > -->
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue'
import { useStoreLists } from '@/stores/storeLists'
const props = defineProps({
  list: Object,
  collapsed: Boolean
})

const storeLists = useStoreLists()

const items = computed(() => {
  return storeLists.getListItemsByListId(props.list.id)
})

const defaultListIcons = {
  seen: 'eye',
  favourites: 'heart',
  watchlist: 'clapperboard-play',
  reviews: 'star',
  'your circle': 'screen-users',
  recents: 'clock'
}

const listIcon = computed(() => {
  if (props.list.icon) return props.list.icon
  if (defaultListIcons[props.list.title.toLowerCase()])
    return defaultListIcons[props.list.title.toLowerCase()]

  return 'list'
})

const listBackdropUrl = computed(() => {
  if (props.list.is_system) {
    return '/backgrounds/list-system.png'
  }
  if (props.list.backdrop_path) {
    return `https://image.tmdb.org/t/p/w300${props.list.backdrop_path}`
  }
  return '/placeholder.png'
})

const hasBackdrop = computed(() => {
  return props.list.backdrop_path || isAuto.value
})

const isSystem = computed(() => {
  return props.list.is_system
})

const isAuto = computed(() => {
  if (props.list.system_type === 'seen') return false // This is a special case (and wrong in the db)
  if (props.list.system_type === 'recents') return false // This is a special case (and wrong in the db)
  return props.list.is_auto
})

const showBackdrop = computed(() => {
  return !isAuto.value && hasBackdrop.value
})

const itemsCount = computed(() => {
  // First try to get count from list_items array if it exists
  if (props.list.list_items && props.list.list_items.length > 0) {
    return props.list.list_items[0].count
  }

  // Fallback to looking at actual items in store
  if (props.list.id) {
    const items = storeLists.getListItemsByListId(props.list.id)
    if (items && items.length > 0) {
      return items.length
    }
  }

  return 0 // Return 0 if no count information is available
})
</script>
<style scoped>
.spectra_list_card {
  background-color: rgb(0, 0, 0);
  background-image:
    radial-gradient(at 10% 90%, rgb(137, 91, 245) 0px, transparent 50%),
    radial-gradient(at 60% 10%, rgb(61, 132, 245) 0px, transparent 50%),
    radial-gradient(at 90% 30%, rgb(34, 195, 93) 0px, transparent 50%),
    radial-gradient(at 70% 80%, rgb(249, 116, 21) 0px, transparent 50%),
    radial-gradient(at 20% 40%, rgb(231, 176, 8) 0px, transparent 50%),
    radial-gradient(at 40% 70%, rgb(236, 70, 153) 0px, transparent 50%),
    radial-gradient(at 85% 15%, rgb(238, 68, 68) 0px, transparent 50%);
}
</style>
